import { useAtom } from "jotai";
import { useItemsFilter } from "../../_helper/actions/app/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import "../css/ConsultationAdviceDirection.css";
import OtherIcons from "./OtherIcons";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import { useEffect, useRef, useState } from "react";
import { useCreateItem } from "../../_helper/actions/mutation/items";
import CuModal from "../../common_component/component/CuModal";
import CuInput from "../../all-patient/components/CuInput";
import { toast } from "react-toastify";
import CuButton from "../../all-patient/components/CuButton";
// import { CONSULTATION_ICONS } from "../../cufront-assets/icons/Icons";

const ConsultationAdviceDirection = ({ advices, setAdvices }) => {
  const [clinic] = useAtom(clinicAtom);
  const [searchInput, setSearchInput] = useState("");
  const [adviceInput, setAdviceInput] = useState("");
  const [adviceName, setAdviceName] = useState("");
  const [selectedOption, setSelectedOption] = useState(0);
  const [isAddNew, setIsAddNew] = useState(false);
  const containerRef = useRef(null);
  const optionRef = useRef([]);

  const { data: advicesData } = useItemsFilter(
    ApiEndPoint.ADVICES,
    `?action=getAdvices&frontend=True&clinic_id=${clinic?.id}&name=${searchInput}&description=${searchInput}`,
    searchInput?.length > 0 && clinic?.id ? true : false
  );

  useEffect(() => {
    if (advices) {
      setAdviceInput(advices?.description);
    }
  }, [advices]);

  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === "Escape") {
        setIsAddNew(false);
      }
    };

    document.addEventListener("keydown", handleEscKey);

    return () => {
      document.removeEventListener("keydown", handleEscKey);
    };
  }, []);

  const handleSearch = (e) => {
    setSearchInput(e.target.value);
    setAdviceInput(e.target.value);
  };

  const handleSelectOption = (value) => {
    setAdvices(value);
    setAdviceInput(value?.description);
    setSearchInput("");
  };

  const createAdvice = useCreateItem(ApiEndPoint.ADVICES, null, false);

  const handleAddNewAdvice = () => {
    const payload = {
      action: "postAdvices",
      frontend: "True",
      clinic_id: clinic?.id,
      status: "draft",
      sort: 0,
      name: adviceName,
      description: adviceInput,
    };

    createAdvice.mutate(payload, {
      onSuccess: (data) => {
        handleSelectOption(data?.data);
        toast.success("Advice added successfully");
        handleCloseModal();
      },
      onError: () => {
        toast.error("Something went wrong please try again");
      },
    });
  };

  const handleKeyEvent = (e) => {
    if (e.key === "ArrowDown" && selectedOption < advicesData?.length - 1) {
      e.preventDefault();
      setSelectedOption((prev) => prev + 1);
      const selectedOptionElement = optionRef.current[selectedOption + 1];
      if (selectedOptionElement) {
        const containerRect = containerRef.current.getBoundingClientRect();
        const optionRect = selectedOptionElement.getBoundingClientRect();
        if (optionRect.bottom > containerRect.bottom) {
          containerRef.current.scrollTop +=
            optionRect.bottom - containerRect.bottom;
        }
      }
    } else if (e.key === "ArrowUp" && selectedOption > 0) {
      e.preventDefault();
      setSelectedOption((prev) => prev - 1);
      const selectedOptionElement = optionRef.current[selectedOption - 1];
      if (selectedOptionElement) {
        const containerRect = containerRef.current.getBoundingClientRect();
        const optionRect = selectedOptionElement.getBoundingClientRect();
        if (optionRect.top < containerRect.top) {
          containerRef.current.scrollTop -= containerRect.top - optionRect.top;
        }
      }
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (searchInput?.length > 0 && advicesData?.length > 0) {
        optionRef.current[selectedOption].click();
      }
      if (searchInput?.length > 0 && advicesData?.length === 0) {
        optionRef.current[0].click();
      }
      setSelectedOption(0);
    }
  };

  const handleCloseModal = () => {
    setIsAddNew(false);
    setAdviceName("");
  };

  const handleClearAdvice = () => {
    setAdviceInput("");
    setAdvices({ id: null });
    setSearchInput("");
  };

  return (
    <div className="cu-consultation-advicedirection-container">
      <div className="cu-consultation-advicedirection-label-cont">
        <label className="cu-consultation-customfield-label">
          Advice & Direction
        </label>
        <OtherIcons type={"advice&direction"} setData={handleSelectOption} />
      </div>
      <div className="cu-consultation-advicedirection-input">
        <textarea
          onChange={handleSearch}
          value={adviceInput}
          onKeyDown={handleKeyEvent}
        />
        <div className="flex justify-end">
          <span
            className="cursor-pointer text-[#0000EE]"
            onClick={handleClearAdvice}
          >
            Clear
          </span>
        </div>
        {advicesData?.length > 0 && searchInput?.length > 0 && (
          <div
            className="cu-consultation-advicedirection-suggestion-list"
            ref={containerRef}
          >
            {advicesData?.map((advc, idx) => {
              return (
                <div
                  className={`cu-consultation-advicedirection-suggestion-list-item ${
                    selectedOption === idx
                      ? "cu-consultation-advicedirection-suggestion-list-item-active"
                      : ""
                  }`}
                  onClick={() => handleSelectOption(advc)}
                  ref={(el) => (optionRef.current[idx] = el)}
                >
                  {advc?.description}
                </div>
              );
            })}
          </div>
        )}
        {searchInput?.length > 0 && advicesData?.length === 0 && (
          <div
            className="cu-consultation-advicedirection-suggestion-list"
            ref={containerRef}
          >
            <div
              className="cu-consultation-advicedirection-suggestion-list-item-active"
              onClick={() => setIsAddNew(true)}
              ref={(el) => (optionRef.current[0] = el)}
            >
              Add New Advice
            </div>
          </div>
        )}
      </div>
      {isAddNew && (
        <CuModal closeModal={handleCloseModal}>
          <div>
            <div className="border-b pb-1 mb-3">Add New Advice</div>
            <div>
              <CuInput
                label={"Name"}
                value={adviceName}
                onChange={(e) => setAdviceName(e.target.value)}
              />
            </div>
            <div className="mt-4 w-full flex justify-end items-center gap-2">
              <CuButton
                className="w-32 h-11 rounded-lg helvetica"
                onClick={() => setIsAddNew(false)}
                // isLoading={createAdvice.isLoading}
              >
                Cancel
              </CuButton>
              <CuButton
                className="w-32 h-11 rounded-lg helvetica bg-[#EBF8EC]"
                onClick={handleAddNewAdvice}
                isLoading={createAdvice.isLoading}
              >
                Save
              </CuButton>
            </div>
          </div>
        </CuModal>
      )}
    </div>
  );
};

export default ConsultationAdviceDirection;
